function SectionFaqPayments() {
    return (
        <>
            <div className="tw-faq-section">
                <div className="accordion tw-faq" id="sf-faq-accordion-3">
                    {/*one*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ1-3" aria-expanded="false">
                            What Makes Your Job Portal So Useful?
                        </button>
                        <div id="FAQ1-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                We provide advanced hiring features including instant search match alerts, candidate communication tools, structured application forms, and analytics trackers.
                            </div>
                        </div>
                    </div>
                    {/*two*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ2-3" aria-expanded="false">
                            Reset Password With Phone Number?
                        </button>
                        <div id="FAQ2-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                Yes, you can submit a password reset code to your registered mobile phone number or secure email during the verification workflow.
                            </div>
                        </div>
                    </div>
                    {/*three*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ3-3" aria-expanded="false">
                            How do I redeem a coupon?
                        </button>
                        <div id="FAQ3-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                Apply the coupon code string inside the pricing checkout pane before finalizing any subscription purchase to reduce the total bill cost immediately.
                            </div>
                        </div>
                    </div>
                    {/*four*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ4-3" aria-expanded="false">
                            How long will it take to post my job?
                        </button>
                        <div id="FAQ4-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                Jobs are stored as drafts and published immediately upon moderator approval, ensuring high quality listings for seekers.
                            </div>
                        </div>
                    </div>
                    {/*five*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ5-3" aria-expanded="false">
                            What is your cancellation policy?
                        </button>
                        <div id="FAQ5-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                You can cancel recurring package subscriptions at any time via your user billing section without experiencing any cancellation fees.
                            </div>
                        </div>
                    </div>
                    {/*six*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ6-3" aria-expanded="false">
                            Where Can I Find Market Research Reports?
                        </button>
                        <div id="FAQ6-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                Sector metrics and market trends are updated periodically on the admin site content logs and accessible directly from the employer profile.
                            </div>
                        </div>
                    </div>
                    {/*seven*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ7-3" aria-expanded="false">
                            Do I need to know PHP to use TheJobs?
                        </button>
                        <div id="FAQ7-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                No programming knowledge is required. Our dashboard layout is completely visual, allowing anyone to post jobs instantly.
                            </div>
                        </div>
                    </div>
                    {/*eight*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ8-3" aria-expanded="false">
                            How soon will I start receiving resumes?
                        </button>
                        <div id="FAQ8-3" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-3">
                            <div className="accordion-body">
                                Resumes will appear in your employer applicants list as soon as seekers submit their details via the public details application forms.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SectionFaqPayments;
